let initialStepData = {
    fullName: '',
    aadhar: '',
    photo: null,
    fileName:'',
    imagePreviewUrl:'',
    siblings: false,
    dateOfBirth: '',
    class: '',
    birthPlace: '',
    nationality: '',
    religion: '',
    motherTongue: '',
    gender: '',
    stream:'',
    physical: '',
    option: '',
    transport: '',
    sibling1Name: '',
    sibling2Name: '',
    sibling1Class: '',
    sibling2Class: '',
    sibling1Section: '',
    sibling2Section: '',
  };
  
  export default initialStepData;
  